<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>KIDNAPPED BY   THE TALIBAN </title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ser"><img alt="97807180113_0020_001.jpg" class="maxwidth" id="p0020-d6e5" src="images/97807180113_0020_001.jpg"/><a id="pagexx"></a></p><a id="pagexx">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// forward1.vue?e0e9512a